export const paddingOne = "0";
export const paddingTwo = "00";
export const paddingThree = "000";